import { getRouterService } from '@/core/container/ioc'
import { computed } from '@/composition/vue/compositionApi'

export const useCurrentRoute = () => {
  const routerService = getRouterService()
  return computed(() => routerService.getCurrentRoute())
}
